import api from '@/api'

export default {
  namespaced: true,
  state: {
    items: [],
    fetching: false
  },
  actions: {
    async fetchBrands ({ state, commit, getters }) {
      commit('fetching')

      const brands = await api.netshoes.getBrands()

      commit('setFetchData', brands)
    }
  },
  getters: {
    getBrands: state => () => state.items
  },
  mutations: {
    setFetchData (state, items) {
      state.items = items
      state.fetching = false
    },
    fetching (state) {
      state.fetching = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/brands.js